import {Fragment, lazy, Suspense} from 'react'

import PropTypes from 'prop-types'

import {MoleculeModalContent, moleculeModalSizes} from '@s-ui/react-molecule-modal'

import {BASE_CLASS} from '../../config.js'

const LazyModal = lazy(() =>
  import(/* webpackChunkName: "FormVehiclesSelectPopoverModal" */ '@s-ui/react-molecule-modal')
)

const FormFilterSelectPopoverModalContent = ({actions, content, isOpen, setIsOpen}) => {
  const handleModalCancel = () => {
    setIsOpen(false)
  }

  return (
    isOpen && (
      <Suspense fallback={Fragment}>
        <div className={`${BASE_CLASS}-modal`}>
          <LazyModal
            closeOnEscKeyDown
            closeOnOutsideClick
            fitWindow
            isContentless
            isOpen={isOpen}
            isPageScrollable={false}
            onClose={handleModalCancel}
            size={moleculeModalSizes.LARGE}
          >
            <MoleculeModalContent withoutIndentation>{content}</MoleculeModalContent>
            {actions}
          </LazyModal>
        </div>
      </Suspense>
    )
  )
}

FormFilterSelectPopoverModalContent.propTypes = {
  actions: PropTypes.node,
  content: PropTypes.node,
  isOpen: PropTypes.bool,
  setIsOpen: PropTypes.func
}

export default FormFilterSelectPopoverModalContent
